module.exports = __webpack_public_path__ + "static/media/jatoba.33a1b42a.jpeg";